import storage from './storage'

export const getItem = storage.getItem
export const setItem = storage.setItem
export const removeItem = storage.removeItem

export default storage
